<template>
    <v-app id="app">
        <v-snackbar v-model="show"
                    :bottom="y === 'bottom'"
                    :left="x === 'left'"
                    :multi-line="mode === 'multi-line'"
                    :right="x === 'right'"
                    :timeout="timeout"
                    :top="y === 'top'"
                    :vertical="mode === 'vertical'">
            {{ message  }}
            <v-icon color="white"
                    style="font-size:14pt; margin-left:15px"
                    flat
                    @click="show = false">
                fa-times
            </v-icon>
        </v-snackbar> <!-- Snackbar  -->



        <v-toolbar color="lightgrey"
                   light
                   app
                   fixed>
            <v-toolbar-title style="margin-left:-12px">

                <v-toolbar-side-icon v-if="this.$route.path !='/landing'" style="margin-bottom:10px" @click="uiEvent('Back')">
                    <v-icon> arrow_back</v-icon>
                </v-toolbar-side-icon>

             
                <span>
                    <router-link to="/landing" style="color:black; text-decoration:none">{{ getPageTitle() }}</router-link>
                </span>
            </v-toolbar-title> <!-- Menubar: Hamurger/Back und Titel -->


            <v-spacer></v-spacer>



            <v-btn v-if="!this.$store.getters.isAuthenticated && this.$route.path == '/landing'"
                   @click="uiEvent('login')">
                Anmelden
            </v-btn>
            <v-btn v-if="!this.$store.getters.isAuthenticated && this.$route.path == '/landing'"
                   @click="uiEvent('createaccount')">
                Konto eröffnen
            </v-btn><!-- Linker Teil des Menubars (Anmeldung und Create Accunt) -->


            <v-menu bottom left v-if="this.$store.getters.isAuthenticated && this.$store.getters.isUserActive && this.$route.path == '/landing'">
                <v-btn slot="activator"
                       icon>
                    <v-icon>account_circle</v-icon>
                </v-btn>


                <v-list>
                    <v-list-tile v-for="(item, i) in profile_items"
                                 :key="i"
                                 @click="uiEvent(item.text)">
                        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>

            </v-menu> <!-- Linker Teil des Menubars (Profil) -->


            <v-menu bottom left v-if="isAdmin()">
                <v-btn slot="activator"
                       icon>
                    <v-icon>https</v-icon>
                </v-btn>

                <v-list>
                    <v-list-tile v-for="(item, i) in admin_items"
                                 :key="i"
                                 @click="uiEvent(item.text)">
                        <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                    </v-list-tile>
                </v-list>

            </v-menu> <!-- menubar: drei punkte (drezeit nicht gebraucht) -->


        </v-toolbar> <!-- Menue -->

        <v-content>

            <router-view></router-view>
            <footer>
                <cookie-law theme="dark-lime"
                            buttonText="Ok"
                            v-bind:message="$t('global.cookieQuestion')"></cookie-law>
            </footer>

        </v-content> <!-- Cookie Frage -->

    </v-app>

</template>

<script>
    import firebase from 'firebase/compat/app';
    import 'firebase/compat/auth';

    const config = require('./classes/myConfig').config;

    import CookieLaw from 'vue-cookie-law'

    console.log("APP.VUE : " + "INIT ");
    export default {
        components: {
            CookieLaw
        },

        data: function () {
            return {

                message: '', // for snackbar
                show: false,
                x: 'right',
                y: 'top',
                mode: '',
                timeout: 6000,

                dialog: false,
                drawer: false,

                // --------- Momentan nicht gebraucht
                /* dropdown_items: [
                    { text: 'Studierende' },
                    { text: 'Unternehmen' }
                ],
                */

               

                profile_items: [
                    { text: 'Profil' },
                    { text: 'Abmelden' },
                    { text: 'Konto löschen' }
                ],

               
                admin_items: [
                    { text:"Admin"  },

                    { text:"M2" },

                ],
            }

        },

        props: {
            source: String
        },


        computed: {

        },

        methods: {
            isAuthenticed() {
                return this.$store.getters.isAuthenticated && this.$store.getters.isUserActive;
            },

            isAdmin() {

                return this.$store.getters.isAdmin
            },

            getPageTitle: function () {

                switch (this.$route.path) {
                    case '/landing':
                        return this.$store.getters.isAdmin ? process.env.VUE_APP_TITLE + "[ADM]" : process.env.VUE_APP_TITLE;

                    case '/ml':
                        return 'Machine Learning Case Studies';

                    case '/speechtotext':
                        return 'Spracherkennung';

                    case '/deleteaccount':
                        return 'Konto löschen';

                    case '/chatbot':
                        return 'Chatbot';

                    case '/privacy':
                        return 'Impressum';

                    case '/profile':
                        return 'Profil';

                    case '/createaccount':
                        return 'Konto eröffnen';

                    case '/login':
                        return 'Anmelden';

                    case '/ecc':
                        return 'S4/Hana Access';

                    case '/it3formulare':
                        return 'IT3 Formulare (SS 2019)';


                    case '/admin':
                        return 'Admin';

                     case '/einsicht':
                        return 'Klausureinsicht';

                    case '/tests':
                        return 'Online-Tests';

                }

                return "Unbekannte Seite";

            },

            uiEvent(s) {

                switch (s) {

                    case "login":
                        this.$router.push({ name: 'login' });
                        break;

                    case "createaccount":
                        this.$router.push({ name: 'createaccount' });
                        break;

                    case "Back":
                    case "Home":
                        this.$router.push({ name: 'landing' });
                        break;

                    case "Settings":
                        this.$router.push({ name: 'profile' });
                        break;

                    case "Abmelden":
                        firebase.auth().signOut();
                        this.$store.commit('setSnackbarText', 'Sie sind abgemeldet.');
                        break;

                    case "Konto löschen":
                        this.$router.push({ name: 'deleteaccount' });
                        break;

                    case "Profil":
                        this.$router.push({ name: 'profile' });
                        break;

                    
                    case "Impressum und Datenschutz":
                        this.$router.push({ name: 'DataProtection' });
                        break;

                    case "Test":
                        this.$router.push({ name: 'vpSap' });
                        break;

                    case "Spracherkennung":
                        break;

                    case "Chatbot":
                        console.log("Bot");
                        this.$router.push({ name: 'Chatbot' });
                        break;

                    case "Books & Scripts":
                        window.open(config.getBaseUrl() + "static/bib/", '_blank');
                        return;

                    case "SAP ERP":
                        if (!this.$store.getters.isStudent) {
                            this.$router.push({ name: 'vpsap' });
                            this.drawer = false; // Close the menue
                            this.$store.commit('setSnackbarText', 'Derzeit nur nach Anmeldung für Studierende der HAW verfügbar.');
                        }
                        else {
                            this.$router.push({ name: 'vpsap' });
                        }
                        return;

                   
                    case "IT3 Formulare":
                        this.$router.push({ name: 'it3formulare' });
                        return;

                    case "Admin":
                        this.$router.push({ name: 'admin' });
                        return;

                    default:
                        console.log("no match");
                        break;
                }

            }

        },

        mounted() {
        },

        created() {
            console.log("APP.VUE : " + "---- CREATED IN APP.VUE ----------------");

            // For the globale snackbar
            this.$store.watch(state => state.snackbarText, () => {
                const msg = this.$store.state.snackbarText
                if (msg !== '') {
                    this.show = true;
                    this.message = msg;
                    this.$store.commit('setSnackbarText', '');
                }
            });


        }

    }
</script>

/* This are global styles
<style>

    .toolbartitle {
        color: lightblue !important;
        background-color: green;
        margin: 0px !important;
    }

    .toolbar {
        background-color: lightblue !important;
        padding: 0px !important;
        margin: 0px !important;
    }

    /* Extra small devices (phones, 600px and down)
        This is xs in Vuetify
    */
    @media only screen and (max-width: 600px) {
        .glTextBox {
            margin-top: 30px;
            margin-left: 20px;
            margin-bottom: 40px;
        }

        .glImage {
        }

        .responsiveContainer {
            margin-top: 2em;
            margin-left: 1em;
            background-color: lightblue;
            width: calc(100% - 2em);
            font-family: 'Segoe UI', sans-serif;
            line-height: 1.5;
            font-weight: 400;
            text-align: left;
        }
    }

    /* Big Screen Classes */
    @media only screen and (min-width: 600px) {
        .glTextBox {
            margin-top: 60px;
            margin-left: 50px;
            margin-bottom: 40px;
        }

        .responsiveContainer {
            background-color: yellow;
            margin-top: 2em;
            width: 800px;
            margin-left: calc((100% - 800px)/2);
            font-family: 'Segoe UI', sans-serif;
            line-height: 1.5;
            font-weight: 400;
            text-align: left;
        }
    }

    .rot {
        background-color: red
    }

    .gelb {
        background-color: yellow
    }

    .blau {
        background-color: lightblue
    }

    .weiss {
        background-color: white
    }
</style>
